<template>
  <router-view />
</template>

<script setup lang="ts">
// App root component
</script>

<style>
/* Global styles are imported in main.ts */
</style>
